export default __webpack_public_path__ + "static/media/gallery_10.9cf8e459.jpg";